import { Sender } from 'xstate';

import UserAction from '../../../ports-frontend/UserAction';
import asyncCallback from '../../../framework/logic/utils/asyncCallback';

export const watchUserAction = () =>
  asyncCallback(
    async (
      callback: Sender<{
        type: 'ENVIROMENT_USER_ACTION_TRIGGERED';
      }>
    ) => {
      const subscriptions: Function[] = [];
      subscriptions.push(
        await UserAction.onUserInteraction(() => {
          callback({
            type: 'ENVIROMENT_USER_ACTION_TRIGGERED',
          });
        })
      );
      return () => {
        subscriptions.forEach(unsub => unsub());
      };
    }
  );
